import React, { useEffect } from 'react';
import { Box, useColorModeValue, Text} from '@chakra-ui/react';
import { motion } from 'framer-motion';

// Motion Box wrapper
const MotionBox = motion(Box);

export const LoadingOverlay = ({loadingMessage = "Loading..."}) => {
  const spinnerColor = useColorModeValue('blue.800', 'blue.300');

  // Lock the scroll when the component is mounted
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    // Restore scroll when the component unmounts
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, []);

  return (
    <MotionBox
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      bg="rgba(0, 0, 0, 0.6)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex={9999}
      aria-live="assertive"
      role="status"
    >
      <Box textAlign="center">
        <span className="loader"></span>
        {/* <Text mt={2} color="blue.500" fontWeight="medium" marginTop="5px" fontSize="22px" textTransform="capitalize">
          {loadingMessage}
        </Text> */}
      </Box>
    </MotionBox>
  );
};
